if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.touchStart = null;
      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.stepPhoto(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      this.addEventListener('touchstart', (event) => {
        this.touchStart = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
      }, { passive: true });
      this.addEventListener('touchcancel', () => { this.touchStart = null; });
      this.addEventListener('touchend', (event) => {
        const start = this.touchStart;
        this.touchStart = null;
        if (!start || !event.changedTouches.length || event.touches.length) return;
        const dx = event.changedTouches[0].clientX - start.x;
        const dy = event.changedTouches[0].clientY - start.y;
        if (Math.abs(dx) >= 45 && Math.abs(dx) > Math.abs(dy) * 1.4) this.stepPhoto(dx < 0 ? 1 : -1);
      }, { passive: true });
    }
    hide() {
      this.touchStart = null;
      super.hide();
    }
    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }
    photoItems() {
      return Array.from(this.querySelectorAll('.product-media-modal__content > img[data-media-id]'));
    }
    showActiveMedia() {
      const id = this.openedBy.getAttribute('data-media-id');
      const active = Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]')).find(item => item.dataset.mediaId === id);
      if (active) this.activateMedia(active);
    }
    activateMedia(active) {
      this.querySelectorAll('.product-media-modal__content > [data-media-id]').forEach(item => item.classList.toggle('active', item === active));
      const container = this.querySelector('[role="document"]');
      if (container) { container.scrollLeft = 0; container.scrollTop = 0; }
      const template = active.querySelector('template');
      if (active.nodeName === 'DEFERRED-MEDIA' && template && template.content.querySelector('.js-youtube')) active.loadContent();
      this.updatePhotoControls();
    }
    stepPhoto(delta) {
      const photos = this.photoItems();
      const index = photos.findIndex(item => item.classList.contains('active'));
      if (photos.length < 2 || index < 0) return;
      this.activateMedia(photos[(index + delta + photos.length) % photos.length]);
    }
    updatePhotoControls() {
      if (!this.photoControls) {
        const dialog = this.querySelector('.product-media-modal__dialog');
        if (!dialog) return;
        const controls = document.createElement('div');
        controls.className = 'lp-photo-controls';
        const previous = document.createElement('button');
        previous.type = 'button'; previous.className = 'lp-photo-previous'; previous.setAttribute('aria-label', 'Previous image'); previous.textContent = '‹';
        const next = document.createElement('button');
        next.type = 'button'; next.className = 'lp-photo-next'; next.setAttribute('aria-label', 'Next image'); next.textContent = '›';
        const counter = document.createElement('span'); counter.className = 'lp-photo-counter'; counter.setAttribute('aria-live', 'polite');
        previous.addEventListener('click', event => { event.stopPropagation(); this.stepPhoto(-1); });
        next.addEventListener('click', event => { event.stopPropagation(); this.stepPhoto(1); });
        controls.append(previous, counter, next); dialog.append(controls);
        this.photoControls = controls; this.photoCounter = counter;
      }
      const photos = this.photoItems();
      const index = photos.findIndex(item => item.classList.contains('active'));
      this.photoControls.hidden = photos.length < 2 || index < 0;
      this.photoCounter.textContent = index < 0 ? '' : `${index + 1} / ${photos.length}`;
    }
  });
}
